export const ROUTE_PATHS = {
  login: "/login",
  notFound: "/not-found",
  dashboard: "/dashboard",
  tasks: "/tasks",
  channels: "/channels",
  channelsAccount: "/channels/account",
  channelsApplication: "/channels/application",
  consumerPool: "/consumer-pool",
  alerts: "/alerts",
  notifications: "/notifications",
  reports: "/reports",
};
